export const severityGrids = {
  addSeverityGrid: "Ajouter une grille de sévérité",
  create: {
    title: "Créer une grille de sévérité",
  },
  delete: {
    label: "Supprimer la grille de sévérité",
  },
  form: {
    name: { label: "Nom" },
    description: { label: "Description" },
    translation: { label: "Traduction" },
  },
  list: {
    name: "Nom",
  },
};
